import { useEffect } from "react";
import { recordPromoOpen } from "@/api/visitor.api";
import { AuthContextProps } from "@/providers/AuthProvider";

// Keyed per promo rather than per hook instance: the badge surface resolves its promo
// ref long after the provider mounts, and remounts on every navigation back to it.
const trackedPromoIds = new Set<string>();

const useTrackPromoVisit = (context: AuthContextProps, promoId?: string) => {
  useEffect(() => {
    if (!context.isLoggedIn || !promoId || trackedPromoIds.has(promoId)) {
      return;
    }

    trackedPromoIds.add(promoId);
    // Analytics-only ping — a failure here must never surface in the widget.
    recordPromoOpen(context, promoId).catch(() => {});
  }, [context, promoId]);
};

export default useTrackPromoVisit;
